var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowToVote2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.678,
    height: 181,
    viewBox: "0 0 137.678 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2711",
    "data-name": "Rectangle 2711",
    width: 99.572,
    height: 100.032,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_315",
    x: 0,
    y: 4,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1805",
    "data-name": "Group 1805",
    transform: "translate(-766 -997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1574",
    "data-name": "Group 1574",
    transform: "translate(785 997)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    width: 118.678,
    height: 181,
    rx: 10,
    transform: "translate(0 0)",
    fill: "#7ca0fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 89.313,
    height: 127.175,
    transform: "translate(0 34.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2690",
    "data-name": "Rectangle 2690",
    width: 68.65,
    height: 1.784,
    transform: "translate(0 39.426)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2691",
    "data-name": "Rectangle 2691",
    width: 70.825,
    height: 1.783,
    transform: "translate(0 42.689)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2692",
    "data-name": "Rectangle 2692",
    width: 25.872,
    height: 1.783,
    transform: "translate(0 45.952)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2693",
    "data-name": "Rectangle 2693",
    width: 70.825,
    height: 1.783,
    transform: "translate(0 52.477)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2694",
    "data-name": "Rectangle 2694",
    width: 70.825,
    height: 1.783,
    transform: "translate(0 55.74)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2695",
    "data-name": "Rectangle 2695",
    width: 67.925,
    height: 1.783,
    transform: "translate(0 59.003)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2696",
    "data-name": "Rectangle 2696",
    width: 70.1,
    height: 1.783,
    transform: "translate(0 62.266)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 13.909,
    height: 1.784,
    transform: "translate(0 65.528)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2698",
    "data-name": "Rectangle 2698",
    width: 70.825,
    height: 1.784,
    transform: "translate(0 72.053)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2699",
    "data-name": "Rectangle 2699",
    width: 69.737,
    height: 1.784,
    transform: "translate(0 75.316)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2700",
    "data-name": "Rectangle 2700",
    width: 70.825,
    height: 1.783,
    transform: "translate(0 78.579)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2701",
    "data-name": "Rectangle 2701",
    width: 70.825,
    height: 1.783,
    transform: "translate(0 81.842)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2702",
    "data-name": "Rectangle 2702",
    width: 69.375,
    height: 1.783,
    transform: "translate(0 85.104)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2703",
    "data-name": "Rectangle 2703",
    width: 70.825,
    height: 1.783,
    transform: "translate(0 88.367)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2704",
    "data-name": "Rectangle 2704",
    width: 68.65,
    height: 1.783,
    transform: "translate(0 91.629)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2705",
    "data-name": "Rectangle 2705",
    width: 70.825,
    height: 1.783,
    transform: "translate(0 94.893)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2706",
    "data-name": "Rectangle 2706",
    width: 69.012,
    height: 1.784,
    transform: "translate(0 98.155)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2707",
    "data-name": "Rectangle 2707",
    width: 2.308,
    height: 1.783,
    transform: "translate(0 101.418)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2708",
    "data-name": "Rectangle 2708",
    width: 2.308,
    height: 1.783,
    transform: "translate(0 123.531)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2709",
    "data-name": "Rectangle 2709",
    width: 70.825,
    height: 1.783,
    transform: "translate(0 107.943)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2710",
    "data-name": "Rectangle 2710",
    width: 65.749,
    height: 1.783,
    transform: "translate(0 111.206)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573",
    transform: "translate(19.105 53.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2915",
    "data-name": "Path 2915",
    d: "M281.935,348.137l.39,19.927,1.948-.038a6.459,6.459,0,0,0,6.331-6.584l-.23-11.736Z",
    transform: "translate(-233.808 -291.558)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2916",
    "data-name": "Path 2916",
    d: "M265.885,350.784l-8.51,18.022,1.762.832a6.459,6.459,0,0,0,8.6-3.082l5.012-10.614Z",
    transform: "translate(-219.356 -293.115)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2917",
    "data-name": "Path 2917",
    d: "M211.569,329.13l11.519-11.979,17.334,16.668a23.993,23.993,0,0,0,17.1,6.694l8.15.6,27.153,23.5,15.031-26.072-24.994-15.34-35.814-24.992-23.636,5.446-23.269,24.2,1.523,1.465a7.005,7.005,0,0,0,9.9-.194",
    transform: "translate(-185.679 -262.183)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2918",
    "data-name": "Path 2918",
    d: "M249.843,349.541l-13.815,14.366,1.4,1.351a6.459,6.459,0,0,0,9.132-.179l8.136-8.461Z",
    transform: "translate(-206.795 -292.384)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2919",
    "data-name": "Path 2919",
    d: "M199.675,394.476a44,44,0,0,1,3.055-3.178,10.544,10.544,0,0,1-2.038-1.594,10.753,10.753,0,0,1-1.608-2.027,43.956,43.956,0,0,1-3.149,3.084,42.706,42.706,0,0,1-3.435,2.759c.513,1.457-.945,4.471-3.606,7.4l.235.235.036-.034,5.214-5.267a.444.444,0,0,1,.013-.547.546.546,0,0,1,.752.752.443.443,0,0,1-.544.015l-5.213,5.265-.036.037.236.233c2.907-2.691,5.9-4.171,7.361-3.673a43.119,43.119,0,0,1,2.728-3.461",
    transform: "translate(-179.061 -314.823)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2920",
    "data-name": "Path 2920",
    d: "M200.014,391.862c1.038-.905,1.987-1.815,2.837-2.7l1.021,1.021-8.475,8.475a7.568,7.568,0,0,0,1.264-4.155l1.321-.973c.666-.515,1.346-1.068,2.033-1.667",
    transform: "translate(-182.887 -315.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2921",
    "data-name": "Path 2921",
    d: "M208.63,395.116a11.578,11.578,0,0,1-1.152-.957l-4.972,4.971a.989.989,0,0,1-.049,1.207.851.851,0,0,1-.742.216l-1.178,1.19a5.32,5.32,0,0,1,2.928-.643c.783-1.092,1.65-2.185,2.581-3.252.844-.968,1.712-1.885,2.585-2.732",
    transform: "translate(-185.911 -318.638)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2922",
    "data-name": "Path 2922",
    d: "M243.374,307.786c-11.867,11.854-22.589,22.9-31.109,31.922l2.5,2.5c9.021-8.522,20.068-19.242,31.922-31.109q2.321-2.324,4.6-4.615l-3.293-3.293q-2.29,2.276-4.615,4.6",
    transform: "translate(-192.813 -265.108)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2923",
    "data-name": "Path 2923",
    d: "M302.1,266.689c10.089-10.234,19.323-20,26.823-28.338l-5.726-5.726c-8.336,7.5-18.1,16.734-28.337,26.824Z",
    transform: "translate(-241.413 -223.588)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2924",
    "data-name": "Path 2924",
    d: "M302.861,266.921c10.124-10.2,19.489-19.836,27.194-27.967l-2.928-2.928c-8.132,7.7-17.77,17.069-27.967,27.194Z",
    transform: "translate(-243.944 -225.59)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2925",
    "data-name": "Path 2925",
    d: "M240.2,303.18c-11.636,12.084-21.978,23.515-30.187,32.845l4.347,4.346c9.332-8.211,20.76-18.55,32.845-30.186q2.366-2.278,4.68-4.534l-7.15-7.15q-2.255,2.314-4.534,4.68",
    transform: "translate(-191.49 -262.35)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2926",
    "data-name": "Path 2926",
    d: "M243.435,307.391c-11.745,11.975-22.355,23.137-30.837,32.194l2.223,2.223c9.059-8.484,20.219-19.091,32.194-30.837q2.344-2.3,4.644-4.57L248,302.747q-2.269,2.3-4.569,4.644",
    transform: "translate(-193.009 -264.849)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2927",
    "data-name": "Path 2927",
    d: "M364.04,227.109l5.456,5.456c1.425-1.576,2.8-3.106,4.09-4.572a7.337,7.337,0,0,0-4.973-4.972c-1.466,1.294-3,2.664-4.573,4.089",
    transform: "translate(-282.12 -217.937)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2928",
    "data-name": "Path 2928",
    d: "M365.163,228.343l3.606,3.606c1.4-1.5,2.739-2.945,4.012-4.331a3.557,3.557,0,0,0-3.286-3.286c-1.386,1.273-2.836,2.616-4.331,4.012",
    transform: "translate(-282.781 -218.708)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2929",
    "data-name": "Path 2929",
    d: "M371.875,226.01l-1.108-1.108h0c-1.4,1.362-2.867,2.794-4.385,4.278L367.6,230.4c1.484-1.517,2.916-2.985,4.278-4.385v0",
    transform: "translate(-283.498 -219.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2930",
    "data-name": "Path 2930",
    d: "M363.635,232l5.764,5.764.428-.475-5.717-5.717-.475.428",
    transform: "translate(-281.882 -222.968)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M371.406,239.746l1.757,1.757.444-.459-1.742-1.742-.458.444",
    transform: "translate(-286.455 -227.517)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2932",
    "data-name": "Path 2932",
    d: "M365.039,233.375l.986.986.447-.455-.978-.978-.455.447",
    transform: "translate(-282.708 -223.767)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2933",
    "data-name": "Path 2933",
    d: "M293.433,296.617l7.33,7.329,1.673-1.732-7.27-7.27-1.733,1.673",
    transform: "translate(-240.574 -260.258)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2934",
    "data-name": "Path 2934",
    d: "M299.581,302.744l3.77,3.77,1.688-1.718-3.74-3.74c-.573.564-1.14,1.119-1.718,1.688",
    transform: "translate(-244.191 -263.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M312.062,275.009c-.2-.2-.66-.072-1.024.292a1.293,1.293,0,0,0-.362.624c-.007-.01-.007-.025-.016-.034-.13-.13-.368,0-.6.236s-.376.482-.246.612.425.015.684-.068a3.336,3.336,0,0,0,1.274-.638c.364-.364.494-.822.292-1.024",
    transform: "translate(-250.182 -248.472)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M331.474,228.939a1.943,1.943,0,0,0-2.693-.313L309.645,247.77s-.654.926-.09,1.489c.326.326,19.689-20.171,19.689-20.171a1.348,1.348,0,0,1,1.865.216,1.814,1.814,0,0,1,.238.3l.376-.376a2.636,2.636,0,0,0-.248-.291",
    transform: "translate(-249.925 -220.992)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M332.636,230.063a1.943,1.943,0,0,0-2.693-.313l-19.428,19.436.463.463c.009-.01,19.428-19.436,19.428-19.436a1.348,1.348,0,0,1,1.865.216,1.807,1.807,0,0,1,.238.3l.376-.376a2.638,2.638,0,0,0-.248-.291",
    transform: "translate(-250.625 -221.653)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M333.221,230.753a1.371,1.371,0,0,0-1.825-.178l-19.158,19.158.119.119c.009-.01.015-.023.025-.033l19.038-19.038a1.347,1.347,0,0,1,1.865.216,1.812,1.812,0,0,1,.238.3l.054-.054a1.879,1.879,0,0,0-.354-.493",
    transform: "translate(-251.638 -222.223)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M311.856,275.406c-.2-.2-.635-.1-.968.236a1.11,1.11,0,0,0-.321.583c-.008-.009-.008-.024-.017-.033-.13-.13-.281-.186-.5.028s-.493.536-.281.748c.13.13.408.033.652-.036a2.888,2.888,0,0,0,1.194-.558c.333-.333.438-.766.236-.968",
    transform: "translate(-250.144 -248.701)",
    fill: "#99b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M266.643,349.626l-28.422.556.014.147a9.874,9.874,0,0,0,8.765,8.92l13.26,2.228,4.613,4.43",
    transform: "translate(-208.086 -292.434)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M266.643,349.626l-28.422.556.014.147a9.874,9.874,0,0,0,8.765,8.92l13.26,2.228,4.613,4.43",
    transform: "translate(-208.086 -292.434)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    x1: 3.183,
    y2: 5.584,
    transform: "translate(39.197 67.485)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x1: 3.183,
    y2: 5.584,
    transform: "translate(39.197 67.485)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 0.123,
    y2: 4.542,
    transform: "translate(48.346 68.517)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x2: 0.123,
    y2: 4.542,
    transform: "translate(48.346 68.517)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 766, 997)",
    filter: "url(#Ellipse_315)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_315-2",
    "data-name": "Ellipse 315",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(9 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    "data-name": "Path 3260",
    d: "M.561,0V-1.785L5.151-6.12A4.819,4.819,0,0,0,5.95-7,2.733,2.733,0,0,0,6.3-7.718a2.152,2.152,0,0,0,.093-.6,1.315,1.315,0,0,0-.484-1.1,2.255,2.255,0,0,0-1.42-.383A3.316,3.316,0,0,0,3.1-9.5a2.694,2.694,0,0,0-1.079.9L.017-9.894a4.692,4.692,0,0,1,1.9-1.615A6.379,6.379,0,0,1,4.743-12.1a5.767,5.767,0,0,1,2.321.434,3.6,3.6,0,0,1,1.547,1.215,3.157,3.157,0,0,1,.552,1.87,4.649,4.649,0,0,1-.144,1.147,3.788,3.788,0,0,1-.578,1.2A9.145,9.145,0,0,1,7.174-4.828L3.366-1.241l-.527-1H9.554V0ZM12.427.136a1.617,1.617,0,0,1-1.165-.468,1.593,1.593,0,0,1-.484-1.2,1.538,1.538,0,0,1,.484-1.182,1.65,1.65,0,0,1,1.165-.451,1.642,1.642,0,0,1,1.173.451,1.552,1.552,0,0,1,.476,1.182,1.607,1.607,0,0,1-.476,1.2A1.609,1.609,0,0,1,12.427.136Z",
    transform: "translate(788 1033)",
    fill: "#005465"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToVote2);
export default __webpack_public_path__ + "static/media/how_to_vote_2.6e4ed75557a8b5ac0c33c8d7b0330813.svg";
export { ForwardRef as ReactComponent };